import { useQuery } from "@tanstack/react-query";
import { auth } from "../../components/Auth/Auth";

// Fetches the existing notifications data.
const getAlerts = async ({ signal }) => {
  const user = auth.currentUser;

  if (!user) {
    throw new Error("No authenticated user found");
  }

  const token = await user.getIdToken();

  const response = await fetch(
    `${import.meta.env.VITE_API_URL}/api/v1/notifications/`,
    {
      signal,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error("Unauthorized: Please log in again.");
    }

    throw new Error(`Failed to fetch alerts: ${response.status}`);
  }

  return response.json();
};

// Loads the existing notifications data.
export const useAlertData = () => {
  return useQuery({
    queryKey: ["alertData"],
    queryFn: getAlerts,

    staleTime: 60_000,

    // Checks periodically for newly created alerts.
    refetchInterval: 15_000,

    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  });
};

// Fetches only settings that are expired or will expire soon.
const getExpiringSettings = async ({ signal }) => {
  const user = auth.currentUser;

  if (!user) {
    throw new Error("No authenticated user found");
  }

  const token = await user.getIdToken();

  const response = await fetch(
    `${import.meta.env.VITE_API_URL}/api/v1/setting/expiring`,
    {
      signal,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error("Unauthorized: Please log in again.");
    }

    throw new Error(`Failed to fetch expiring settings: ${response.status}`);
  }

  return response.json();
};

export const useExpiringSettings = () => {
  return useQuery({
    queryKey: ["expiringSettings"],
    queryFn: getExpiringSettings,

    staleTime: 60_000,

    // Checks periodically for newly created alerts.
    refetchInterval: 15_000,

    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    retry: false,
  });
};
